import cx from "classnames";
import React from "react";

import DownArrow from "./down-arrow.svg";
import UpArrow from "./up-arrow.svg";

type ArrowIconProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const ArrowSelectorIcon = ({ className, ...props }: ArrowIconProps) => (
  <div className={cx("flex flex-col gap-2 h-6", className)} {...props}>
    <UpArrow />
    <DownArrow />
  </div>
);
